// Owner: slides-ai (plan §9.29, §3.4 "Make a deck"). ⌘K → "New presentation with AI": creates a deck and
// opens "Generate slides". Discovered by glob and loaded with the app shell, so this file stays tiny:
// the item and its words load on first use (`command-bar.ts`), and only while AI works for the member.
import { defineAppCommands } from '../../extensions/commands';

export default defineAppCommands({
  id: 'slides-ai',
  providers: [
    {
      id: 'slides-ai.create',
      items: async (query) => (await import('./command-bar')).deckAiCreateItems(query),
    },
  ],
});
